export { NullResultPageForSpecialty } from './NullResultPageForSpecialty';
